/* eslint-disable react/prop-types */
import chair from "../../assets/images/chair.png";

function DraggAbleComponentView({data, fullDetails}) {
    // console.log(data)
  return (
    <div>
        <div id={data?.id} className="cursor-pointer absolute px-5 py-7 flex flex-col items-center justify-center gap-2" style={data?.style} >
            <p className="text-2xl font-medium -mt-10">
                {data?.name} {(data?.isMerged)&& "["+data?.mergedName+"]"}
            </p>
            <div className="flex gap-2 items-center">
                <img className="h-3 w-2" src={chair} alt="chair-icon" />
                <p className="text-base font-medium">{fullDetails.seat}</p>
            </div>
        </div>
        {/* <Moveable
            target={``}
            draggable={true}
            roundable={true}
            rotatable={{
                        renderDirections: DIRECTIONS,
                    }}
            resolveAblesWithRotatable={{
                resizable: ["nw", "ne", "sw", "se", "n", "e", "s"],
            }}
            resizable={{
                renderDirections: true,
            }}

            rotateAroundControls={true}
            isDisplayShadowRoundControls={"horizontal"}
            roundClickable={"control"}
            roundPadding={15}
            onRender={e => {
                e.target.style.cssText += e.cssText;
            }}
            onRenderEnd={e => {
                e.target.style.cssText += e.cssText;
            }}
        /> */}
    </div>
  );
}

export default DraggAbleComponentView;